import { render, staticRenderFns } from "./sglEventsGroups-skeleton.vue?vue&type=template&id=4b2b883a&scoped=true&"
import script from "./sglEventsGroups-skeleton.vue?vue&type=script&lang=js&"
export * from "./sglEventsGroups-skeleton.vue?vue&type=script&lang=js&"
import style0 from "./sglEventsGroups-skeleton.vue?vue&type=style&index=0&id=4b2b883a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2b883a",
  null
  
)

export default component.exports